export function validateDate(date?: string): boolean {
  if (!date) return false

  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/
  const match = date.match(regex)

  if (!match) return false

  const dia = parseInt(match[1], 10)
  const mes = parseInt(match[2], 10)
  const ano = parseInt(match[3], 10)

  // Verifica se a data é válida com o objeto Date
  const dataObj = new Date(ano, mes - 1, dia)

  return dataObj.getFullYear() === ano && dataObj.getMonth() === mes - 1 && dataObj.getDate() === dia
}
